import React from 'react';
import { Box, Grid } from '@mui/material';
import './EmployeesAvailabilityCard.css'


const EmployeesAvailabilityCard = ({ data }) => {

  // Transform the object to an array with labels and colors
  const dataWithColors = [
    {
      count: data?.onSiteEngineersCount || 0,
      label: 'At Site',
      color: '#28a745', // green
    },
    {
      count: data?.onLeaveEngineersCount || 0,
      label: 'On Leave',
      color: '#fd7e14', // orange
    },
    {
      count: data?.availableEngineersCount || 0,
      label: 'Available',
      color: '#007bff', // blue
    },
  ];


  return (
    <Box className="employees-card">
      <span className="employees-card-title">Employees Availability</span>
      <Grid container spacing={3} className="employees-grid" mt={2}>
        {dataWithColors?.map((item, index) => (

          <div key={index} className="employees-grid-item">
            <Box
              className="status-dot"
              sx={{ backgroundColor: item.color }}
            />
            <span className="status-count">{item.count}</span>
            <span className="status-label">{item.label}</span>
          </div>
        ))}
      </Grid>
    </Box>
  );
};

export default EmployeesAvailabilityCard;
